export const loadSupportTickets = async (request, setTickets, setBusy) => {
    if (setBusy) setBusy(true);
    try {
        const data = await request('/api/v1/support/tickets', {});
        setTickets(data || []);
    } finally {
        if (setBusy) setBusy(false);
    }
};

export const createSupportTicket = async (request, payload) => {
    return await request('/api/v1/support/tickets', {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};

export const loadSupportMessages = async (request, ticketId, setMessages, setBusy) => {
    if (!ticketId) return;
    if (setBusy) setBusy(true);
    try {
        const data = await request(`/api/v1/support/tickets/${ticketId}/messages`, {});
        setMessages(data || []);
    } finally {
        if (setBusy) setBusy(false);
    }
};

export const addSupportMessage = async (request, ticketId, payload) => {
    return await request(`/api/v1/support/tickets/${ticketId}/messages`, {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};
